export enum CharBoolean {
  TRUE = '1',
  FALSE = '0',
}
